<template>
  <!-- Older/imported records (e.g. Personio sync) have only the date, without the user -->
  <div v-if="userRole === 'ROLE_ADMIN' && (createdByUserData || createdAt || updatedByUserData)" class="row mb-4">
    <div class="col-md-6 col-12 mb-2 mb-md-0" v-if="createdByUserData || createdAt">
      <div class="audit-info-box">
        <i class="fa fa-plus-circle audit-info-icon text-success"></i>
        <div>
          <small class="text-muted d-block text-uppercase fw-bold" style="font-size: 10px; letter-spacing: 0.5px;">Erstellt</small>
          <span class="text-dark fw-bold" v-if="createdByUserData">{{ createdByUserData.fullName }}</span>
          <span class="text-muted" v-if="createdAt">{{ createdByUserData ? ' am ' : 'Am ' }}{{ createdAt }}</span>
        </div>
      </div>
    </div>
    <div class="col-md-6 col-12" v-if="updatedByUserData">
      <div class="audit-info-box">
        <i class="fa fa-pen audit-info-icon text-primary"></i>
        <div>
          <small class="text-muted d-block text-uppercase fw-bold" style="font-size: 10px; letter-spacing: 0.5px;">Zuletzt geändert</small>
          <span class="text-dark fw-bold">{{ updatedByUserData?.fullName }}</span>
          <span class="text-muted" v-if="updatedAt"> am {{ updatedAt }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {defineProps} from 'vue';

defineProps({
  userRole: {
    type: String,
    default: null,
  },
  createdByUserData: {
    type: Object,
    default: null,
  },
  createdAt: {
    type: String,
    default: null,
  },
  updatedByUserData: {
    type: Object,
    default: null,
  },
  updatedAt: {
    type: String,
    default: null,
  },
});
</script>

<style scoped>

.audit-info-box {
  display: flex;
  align-items: center;
  gap: 12px;
  background-color: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  padding: 10px 14px;
  height: 100%;
}

.audit-info-icon {
  font-size: 18px;
}

</style>
